import hljs from "highlight.js/lib/core";
import javascript from "highlight.js/lib/languages/javascript";

hljs.registerLanguage("javascript", javascript);

export const PINE_SCRIPT_CODE_FONT =
  'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/** Pine-like highlighting via JS grammar (same as read-only code blocks). */
export function highlightPineLikeSource(source: string): string {
  try {
    return hljs.highlight(source, { language: "javascript", ignoreIllegals: true }).value;
  } catch {
    return escapeHtml(source);
  }
}
